export default __webpack_public_path__ + "static/media/png.ab6033fe.svg";